module.exports = __webpack_public_path__ + "img/add_btn_icon111.575cf3e2.svg";